<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Test Examination Questions for {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="testQuestions()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Candidate Number</label>
        <input type="text" placeholder="CAN-0000" class="form-control" [(ngModel)]="candidate"
          [ngModelOptions]="{ standalone: true }">
      </div>
      <button class="btn btn-primary btn-lg col-md-10" type="submit"> TEST
      </button>
    </form>
  </div>
</div>